module.exports = __webpack_public_path__ + "src/img/delete.893d6706.svg";